/**
 * Host-controlled guest-app display settings.
 *
 * The `/bookings/details/:bID` response carries an optional `guestApp`
 * object alongside `booking` / `room` / `accessTimes`. It is optional by
 * design: older and cached responses omit it entirely, so every flag
 * defaults to the permissive (pre-existing) behaviour and only an explicit
 * `false` from the server changes what the guest sees.
 */
export const parseGuestAppConfig = (bookingDetails) => ({
  showLockButton: bookingDetails?.guestApp?.showLockButton !== false,
});

/**
 * Reads the lock-button flag off a booking that `parseGuestAppConfig`
 * stamped when it was built for route state. Bookings that never went
 * through that path — legacy v1 navigation, GraphQL `getBooking`
 * refetches — carry no `guestApp` key, which resolves to `true`: the
 * control stays visible unless the host explicitly turned it off.
 */
export const shouldShowLockButton = (booking) =>
  booking?.guestApp?.showLockButton !== false;
